export class Classification {

    constructor(readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Classification.ts